import { css } from '@linaria/atomic';

export const container = css`
  display: flex;
  align-items: flex-start;
  width: 100%;
  background-color: var(--fabric-color-neutral-00);
`;

export const contentWrapper = css`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: var(--fabric-number-n-2-px);
  padding: var(--fabric-number-n-2-px) var(--fabric-number-n-4-px);
  background-color: var(--fabric-color-neutral-5);
`;

export const iconWrapper = css`
  display: inline-flex;
  flex-shrink: 0;
`;

export const assetsList = css`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-wrap: nowrap;
  overflow: hidden;
  align-items: center;
  gap: var(--fabric-number-n-1-px);
  margin: 0;
  padding: 0;
`;
